import {connect} from "react-redux";
import {State} from "../reducers/index";
import AccountNav from "../components/AccountNav";
import {deleteSession} from "../middleware/loginActions";
import {GenericThunkDispatch} from "../types/Types";
const mapStateToProps = (state: State) => ({
  email: state.login.email,
  firstName: state.login.firstName,
  lastName: state.login.lastName
});
const mapDispatchToProps = (dispatch: GenericThunkDispatch) => {
  return {
    logout: (e: React.MouseEvent<HTMLButtonElement>) => {
      dispatch(deleteSession())
    }
  }
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountNav);
